// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type LogoutIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from logout.svg
 */
export default function LogoutIcon(props: LogoutIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="LogoutIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M10 1a1 1 0 0 0-1-1H1L.883.007A1 1 0 0 0 0 1v14l.007.117A1 1 0 0 0 1 16h8l.117-.007A1 1 0 0 0 10 15l-.007-.117A1 1 0 0 0 9 14H1.999V2H9l.117-.007A1 1 0 0 0 10 1m1.707 2.293-.094-.083a1 1 0 0 0-1.32.083l-.083.094a1 1 0 0 0 .083 1.32L12.585 7H5l-.117.007A1 1 0 0 0 5 9h7.585l-2.292 2.293-.083.094a1 1 0 0 0 1.497 1.32l4-4 .083-.094a1 1 0 0 0-.083-1.32z"
        />
      </g>
    </svg>
  );
}
